import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '../src/Stylesheets/index.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

if(module.hot) {
  module.hot.accept()
}
